import {css, jsx} from '@emotion/react';
import styled from '@emotion/styled';
import {rgb} from 'chalk';
import {darken, lighten} from 'polished';

export const TopRow = styled.div`
    display: flex;
`;